// PRACM_AKIRDT stands for Predicted Risk Assuming Conservative Management - End-stage Kidney Failure Within One Year

// noinspection UnnecessaryLocalVariableJS

import {_PRAIP_ESKF} from './PRAIP_ESKF';
import {FACTOR} from './eqConstants';

export const _PRACM_ESKF = patientHealthFactors => {
  const PRIData = _PRAIP_ESKF(patientHealthFactors);
  const predictedRiskConservative = PRIData.PRI * FACTOR.conservativeMgmt;

  const survivingNextYearWithoutDialysis = {
    PRC: predictedRiskConservative,
    probability: predictedRiskConservative * 100
  };

  return survivingNextYearWithoutDialysis;
};
